<template>
  <div id="footer">
    <!-- <div>
      <img src="../../assets/images/footer_nav/ftl.png" style="position: absolute;left: 0;top: 0;z-index: 1;height: 1.6rem;">
      <img src="../../assets/images/footer_nav/ftm.png" style="position: absolute;left: 50%;top: 0;transform: translateX(-50%);z-index: 1;height: 1.6rem;">
      <img src="../../assets/images/footer_nav/ftr.png" style="position: absolute;right: 0;top: 0;;z-index: 1;height: 1.6rem;">
    </div> -->
    <router-link to="/" class="footer_item" :class="active == 0? 'active' :''">
      <div class="icon_wrap">
         <img v-if="active == 0" src="../../assets/images/footer_nav/nav01_h.png" class="fimg">
         <img v-else src="../../assets/images/footer_nav/nav01.png" class="fimg">
      </div>
      <p class="footer_info">Inicio</p>
    </router-link>
    <router-link to="/share" class="footer_item" :class="active == 1? 'active' :''">
      <div class="icon_wrap">
        <img v-if="active == 1" src="../../assets/images/footer_nav/nav02_h.png" class="fimg">
         <img v-else src="../../assets/images/footer_nav/nav02.png" class="fimg">
      </div>
      <p class="footer_info">Promoção</p>
    </router-link>
    <router-link to="/recharge" class="footer_item" :class="active == 2? 'active' :''">
      <div class="icon_wrap">
         <img  src="../../assets/images/footer_nav/fff.png" class="fff_img">
      </div>
      <p class="footer_info">Fundos</p>
    </router-link>
    <router-link to="/support" class="footer_item" :class="active == 3? 'active' :''">
      <div class="icon_wrap">
        <img v-if="active == 3" src="../../assets/images/footer_nav/nav04_h.png" class="fimg">
         <img v-else src="../../assets/images/footer_nav/nav04.png" class="fimg">
      </div>
      <p class="footer_info">Suporte</p>
    </router-link>
    <router-link to="/person" class="footer_item" :class="active == 4? 'active' :''">
      <div class="icon_wrap">
        <img v-if="active == 4" src="../../assets/images/footer_nav/nav05_h.png" class="fimg">
         <img v-else src="../../assets/images/footer_nav/nav05.png" class="fimg">
      </div>
      <p class="footer_info">Perfil</p>
    </router-link>
  </div>

</template>
<script>
export default {


  data() {
    return {
        active:0,
    };
  },
  created() {
    // console.log(this.active)
      this.$bus.$on('send2ftnav',(idx)=>{
          this.active = idx;
      })
  },

};
</script>
<style lang="less" scoped>
@import  "../../assets/css/variables.less";

@keyframes scaleAnimation {

// 动画设置
0% {
  transform: scale(0.85);
}

25% {
  transform: scale(0.9);
}

50% {
  transform: scale(0.95);
}

75% {
  transform: scale(1.08);
  transform: rotate(360deg);
}
}
#footer {
  position: fixed;
  height: 1.6rem;
  width:100%;
  max-width: 512px;
  bottom: 0;
  display: flex;
  background-color: @headerBgColor;
  z-index: 3;
  background-size: 100%;
}

.footer_item {
  display: flex;
  width: 25%;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 0.3rem 0;
}

.icon_wrap {
  width: 100%;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  z-index: 2;
}
.nav_01{
  background-image: url(../../assets/images/index/nav01.png);
}
.nav_02{
  background-image: url(../../assets/images/index/nav02.png);
}
.nav_03{
  background-image: url(../../assets/images/index/nav03.png);
}
.nav_04{
  background-image: url(../../assets/images/index/nav04.png);
}
.nav_05{
  background-image: url(../../assets/images/index/nav05.png);
}
.ft_icon {
  font-size: 0.667rem;
  color: #8f6ae9;
}

.footer_info {
  font-family: -apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,Segoe UI,Arial,Roboto,PingFang SC,miui,Hiragino Sans GB,Microsoft Yahei,sans-serif;
  color: @textColor;
  margin-top: 0.1rem;
  font-weight: 700;
}
.active .nav_01{
  background-image: url(../../assets/images/index/nav01_h.png);
}
.active .nav_02{
  background-image: url(../../assets/images/index/nav02_h.png);
}
.active .nav_03{
  background-image: url(../../assets/images/index/nav03_h.png);
}
.active .nav_04{
  background-image: url(../../assets/images/index/nav04_h.png);
}
.active .nav_05{
  background-image: url(../../assets/images/index/nav05_h.png);
}
.active .ft_icon{
  font-size: 0.8rem;
  color: #c74cf9
}
.active .footer_info{
  color: @supColor;
 
}
.fimg{
  width: 0.8rem;
}
.fff_img{
  width: 1.2rem;
  margin-top:-0.65rem;
  border: 5px solid @headerBgColor;
  border-radius:50%;
  animation-name: scaleAnimation; // 动画名
  animation-duration: 10s; // 动画时长
  animation-iteration-count: infinite; // 永久动画
  transition-timing-function: ease-in-out; // 动画过渡
}
</style>